export const DIALECTS = {
    athena: "Athena",
    bigquery: "BigQuery",
    clickhouse: "ClickHouse",
    databricks: "Databricks",
    doris: "Doris",
    dremio: "Dremio",
    drill: "Drill",
    druid: "Druid",
    duckdb: "DuckDB",
    dune: "Dune",
    fabric: "Fabric",
    hive: "Hive",
    materialize: "Materialize",
    mysql: "MySQL",
    oracle: "Oracle",
    postgres: "Postgres",
    presto: "Presto",
    prql: "PRQL",
    redshift: "Redshift",
    risingwave: "RisingWave",
    snowflake: "Snowflake",
    solr: "Solr",
    spark: "Spark",
    spark2: "Spark2",
    sqlite: "SQLite",
    starrocks: "StarRocks",
    tableau: "Tableau",
    teradata: "Teradata",
    trino: "Trino",
    tsql: "TSQL",
    exasol: "Exasol"
};
export function isRemoteSourceContent(content) {
    return content.type == "CONNECTION_METADATA";
}
export function filter(input, filter) {
    return {
        type: "FILTER",
        input: input,
        filter: filter
    };
}
export function project(input, project) {
    return {
        type: "PROJECT",
        input: input,
        project: project
    };
}
export function mutate(input, mutate) {
    return {
        type: "MUTATE",
        input: input,
        mutate: mutate
    };
}
export function exclude(input, excludeColumns) {
    return {
        type: "EXCLUDE",
        input: input,
        exclude_columns: excludeColumns
    };
}
export function aggregate(input, groupings, measures) {
    return {
        type: "AGGREGATE",
        input: input,
        groupings: groupings,
        measures: measures
    };
}
export function distinct(input, subset) {
    return {
        type: "DISTINCT",
        input: input,
        subset: subset
    };
}
export function pivot(input, idColumns, wideColumn, wideValues, valueColumn, aggFunc = "first") {
    return {
        type: "PIVOT",
        input: input,
        id_columns: idColumns,
        wide_column: wideColumn,
        wide_values: wideValues,
        value_column: valueColumn,
        agg_func: aggFunc
    };
}
export function unpivot(input, idColumns, variableAlias, valueAlias, valueColumns) {
    return {
        type: "UNPIVOT",
        input: input,
        id_columns: idColumns,
        value_columns: valueColumns,
        variable_alias: variableAlias,
        value_alias: valueAlias
    };
}
export function unpivotAndPivot(input, idColumns, valueColumns, wideColumn, wideValues, variableAlias) {
    return {
        type: "UNPIVOT_PIVOT",
        input: input,
        id_columns: idColumns,
        value_columns: valueColumns,
        wide_column: wideColumn,
        wide_values: wideValues,
        variable_alias: variableAlias
    };
}
export function join(left, right, conditions, how = "LEFT", suffix = "_right") {
    return {
        type: "JOIN",
        left: left,
        right: right,
        conditions: conditions,
        how: how,
        suffix: suffix
    };
}
export function sort(input, sort_by) {
    return {
        type: "SORT",
        input: input,
        sort_by: sort_by
    };
}
export function union(inputs) {
    return {
        type: "UNION",
        inputs: inputs
    };
}
export function sql(input, query, dialect, virtual_table_name, aliased_datasets) {
    return {
        type: "SQL",
        input: input,
        query: query,
        dialect: dialect,
        virtual_table_name: virtual_table_name,
        aliased_datasets: aliased_datasets
    };
}
export function readDataSource(source) {
    return {
        type: "DATA_SOURCE",
        source: source
    };
}
